/* eslint-disable no-param-reassign */
import { createStore } from "vuex";

import artworkModule from "./artwork-module";
import checkoutModule from "./checkout-module";
import creationModule from "./creation-module";
import deliveryModule from "./delivery-module";
import surfaceModule from "./surface-module";
import appModule from "./app-module";
import productModule from "./product-module";

const initialState = {
  config: {}
};

const store = createStore({
  state() {
    return { ...initialState };
  },
  getters: {
    config: state => state.config
  },
  mutations: {
    setConfig(state, value) {
      state.config = value;
    }
  },
  actions: {},
  modules: {
    artwork_front: artworkModule,
    artwork_back: artworkModule,
    surface_front: surfaceModule,
    surface_back: surfaceModule,
    checkout: checkoutModule,
    creation: creationModule,
    delivery: deliveryModule,
    product: productModule,
    app: appModule
  }
});

window.jiffy ||= {};
window.jiffy.madeStore = store;
export default store;
